// extracted by mini-css-extract-plugin
export default {"VoucherPage":"styles_VoucherPage__ZxmZ9","banner":"styles_banner__H7VV8","prompt":"styles_prompt__ZLjUx"};